import { Injectable } from "@angular/core";
import { CreateBookingWS } from "@app/core/booking/data/network/create-booking.ws";
import { BookingRepo } from "@app/core/booking/domain/booking-repo";
import { Booking } from "@app/core/booking/domain/model/booking";
import { GetContactWhatsappNumberWS } from "@app/core/contact/data/get-whatsapp-contact-number.ws";
import { SendMessageWS } from "@app/core/contact/data/send-message.ws";
import { Contact } from "@app/core/contact/domain/contact";
import { ContactRepo } from "@app/core/contact/domain/contact.repo";

import { Observable } from "rxjs";

@Injectable()
export class ContactDataRepo implements ContactRepo {
  constructor(
    private sendMessageWS: SendMessageWS,
    private getContactWhatsappNumberWS: GetContactWhatsappNumberWS
  ) {}

  sendMessage(message: Contact, token: string): Observable<void> {
    return this.sendMessageWS.execute(message, token);
  }

  getWhatsappContactNumber(): Observable<string> {
    return this.getContactWhatsappNumberWS.execute();
  }
}
